<app-loading-section *ngIf="isLoading; else content"></app-loading-section>

<ng-template #content>
  <app-history-list
    *ngIf="!!activities?.length; else empty"
    [list]="activities || []"
    contentKey="log"
    userId="creator_id"
    userNameKey="created_by"
    timeKey="created"
  ></app-history-list>
</ng-template>

<ng-template #empty>
  <ng-content></ng-content>
</ng-template>
